import React, { useState } from 'react'
import Dialog from '../element/Dialog'
import BtnPrimary from '../element/Buttons/btnPrimary'
import ThreeDotLoader from "../element/ButtonLoader/ThreeDotLoader"

const DeleteModal = ({ dialogOpen, onDialogClose, onConfirm, title = "Are you sure you want to delete?", subtitle = "This action cannot be undone." }) => {
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const handleConfirm = () => {
        setButtonDisabled(true);

        if (onConfirm) {
            onConfirm();
        }

        setTimeout(() => {
            setButtonDisabled(false);
            onDialogClose();
        }, 2000);
    };

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            width={320}
            onRequestClose={onDialogClose}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex flex-col items-center justify-center pt-6 px-6 pb-6">
                {/* Delete Icon */}
                <div className="h-12 w-12 bg-[#FF8E1C] rounded-full flex items-center justify-center mb-4">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>

                {/* Close Button */}
                <button
                    onClick={onDialogClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                    
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                {/* Title */}
                <h3 className="text-base font-semibold text-gray-900 mb-2 text-center">
                    {title}
                </h3>

                {/* Subtitle */}
                <p className="text-sm text-gray-500 text-center mb-6">
                    {subtitle}
                </p>

                {/* Buttons */}
                <div className="flex gap-3 w-full">
                    <button
                        className="flex-1 h-10 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 focus:bg-white duration-100"
                        onClick={onDialogClose}
                                            style={{ backgroundColor: "#FFF4E5", borderColor: "#FFF4E5" }}

                    >
                        Cancel
                    </button>

                    <button
                        disabled={buttonDisabled}
                        onClick={handleConfirm}
                        className="flex-1 h-10 rounded-lg border  bg-white text-white text-sm font-semibold "
                        style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                    >
                        {buttonDisabled ? <ThreeDotLoader /> : "Confirm"}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteModal;